import { FixedAssetsScheduleReferenceType } from '@modeso/types__aumico-lib-annualreport-be';

export interface IFixedAssetsScheduleReference {
    reference: string;
    referenceCaption: string;
    referenceType: FixedAssetsScheduleReferenceType;
}
